import React from 'react'
import { connect } from 'react-redux'
import { CrudEventEnum, EntityTypeEnum, FxRateDetail, WorkflowActions } from 'api'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { FxRateDialog } from '../FxRateDialog'
import { CorrelatedResponseCallback } from 'store/notification/notificationTypes'
import { Locale, Translation } from 'locale'

export interface FxRateActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<FxRateDetail> {
  onShowFxRateDialog: (entityTypeEnum: EntityTypeEnum, entityId: string, correlatedResponseCallback?: CorrelatedResponseCallback) => unknown
}

const mapDispatchToProps = {
  onShowFxRateDialog: WorkflowActions.createEditWorkflow
}

const canEditDetails = (item: FxRateDetail) => item.availableEvents.includes(CrudEventEnum.UPSERT)

export const FxRateActionsButtonComponent: React.FunctionComponent<FxRateActionsButtonProps> = props => {
  const { items, isGroupRow, onShowFxRateDialog, showModal } = props

  const editItems = items.filter(item => canEditDetails(item))

  const handleShowItemDialog = (entityId: string) => {
    const correlatedResponseCallback = (workflowId: string) => {
      showModal(<FxRateDialog workflowId={workflowId} entityId={entityId} />)
    }

    onShowFxRateDialog(EntityTypeEnum.FX_RATE, entityId, correlatedResponseCallback)
  }

  const getLabel = (baseLabel: Translation, count: number) => {
    const countLabel = isGroupRow ? ` (${count})` : ``
    return `${Locale.translate(baseLabel)}${countLabel}`
  }

  const actions: ActionItem[] = [
    {
      label: getLabel(Translation.TC_ACTION_EDIT_DETAILS, 1),
      onClick: () => handleShowItemDialog(items[0].fxRate.id),
      enabled: editItems.length === 1
    }
  ]
  return <SplitButtonDropdown actions={actions} maxButtons={1} />
}

export const FxRateActionsButton = withModal(connect(null, mapDispatchToProps)(FxRateActionsButtonComponent))
